// extracted by mini-css-extract-plugin
export default {"root":"WVXLWMCqgehetdQ5mv9A","text":"nTieNqfce4EjOCP1R_ax","input":"EDdzVgwjg_4w_kM7Mnzc","textarea":"TTcnZ57HRFgaceopn7qE"};